// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p[data-v-afe72588]{font-size:1rem}.error[data-v-afe72588]{color:#bd1f23}", "",{"version":3,"sources":["webpack://./src/components/formSponsorship/SectionCui.vue"],"names":[],"mappings":"AACA,mBACE,cAAA,CAGF,wBACE,aAAA","sourcesContent":["\np {\n  font-size: 1rem;\n}\n\n.error {\n  color: #bd1f23;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
